export const UserRoles = {
    SUPERVISOR: 'supervisor',
    PROJECT_MANAGER: 'project_manager',
    EMPLOYER: 'employer',
    MODERATOR: 'moderator',
    CONTRACTOR: 'contractor',
    EDITOR: 'project_editor',
    SAFETY_ENGINEER: 'safety_engineer',
    EMPLOYER_ADDITIONAL: 'employer_additional',
    FIELD_CONTRACTOR: 'field_contractor',
}

export const UserRolesOptions = [
    {value: 'supervisor', label: 'Супервайзер'},
    {value: 'project_manager', label: 'Менеджер проекта'},
    {value: 'employer', label: 'Заказчик'},
    {value: 'moderator', label: 'Модератор'},
    {value: 'contractor', label: 'Подрядчик'},
    {value: 'project_editor', label: 'Руководитель проекта'},
    {value: 'safety_engineer', label: 'ПБ, ОТ и ООС'},
    {value: 'employer_additional', label: 'Дополнительный заказчик'},
    {value: 'field_contractor', label: 'Подрядная организация'},
]